import { jsxs as t, jsx as e } from "react/jsx-runtime";
import r from "../../../assets/logo-dark.svg.js";
import i from "@mui/joy/Typography";
import { Content as o, TextWrapper as l, Title as n } from "./styled.js";
const s = ({ icon: s2, title: d, subtitle: m, hideTitleEndDecorator: a, description: c, width: h }) => t(o, { sx: { maxWidth: h || "400px" }, children: [s2, t(l, { children: [!!m && e(i, { level: "title-sm", fontWeight: 600, textColor: "text.tertiary", children: m }), e(n, { level: "h4", fontWeight: 600, endDecorator: a ? null : e(r, {}), sx: { display: "flex", alignItems: "center", justifyContent: "center" }, children: d }), e(i, { level: "body-sm", textColor: "text.tertiary", children: c })] })] });
export {
  s as WelcomeMessage,
  s as default
};
//# sourceMappingURL=index.js.map
